import React, { useMemo } from 'react';
import { MaterialDetail as MaterialDetailDTO } from '../../api/material';
import { useCapTypes } from '../../components/CapTypeBadges';
import { i18nText } from '../../utils/i18n';
import { TipOwner } from '../../api/tips';
import TipsMountCard from './TipsMountCard';

// 材料详情 › 加工小贴士区. 挂载/排序/新建的交互与设备侧完全一致, 实现在 TipsMountCard;
// 这里只组装材料侧的上下文 —— 表单选项按材料「适配工艺类型」收窄; 列表默认收起, 点「展开」才显示.

function MaterialTipsCard({ detail }: { detail: MaterialDetailDTO }) {
    const { capTypes } = useCapTypes();
    const matName = i18nText(detail.name);

    const owner: TipOwner = useMemo(() => {
        const lights = new Set<string>();
        const crafts = new Set<string>();
        for (const c of detail.capability || []) {
            if (!c.isEnabled) continue;
            const ct = capTypes.find((x) => x.capKey === c.capKey);
            if (!ct) continue;
            lights.add(ct.lightSource);
            crafts.add(ct.action === 'eng' ? 'engrave' : 'cut');
        }
        return {
            kind: 'material',
            key: detail.xcode,
            name: matName,
            lights: [...lights],
            crafts: [...crafts],
        };
    }, [detail.capability, detail.xcode, capTypes, matName]);

    return <TipsMountCard owner={owner} collapsible />;
}

export default MaterialTipsCard;
